/**
 * Mobile Webex cross-launch URL used by the Teams iOS/Android tab.
 * Desktop continues to use CrossLaunchService via useMakeCall.
 */
export const buildMobileCallingUrl = (address: string, video?: boolean): string => {
  const callUrl = new URL('webextel://login');
  callUrl.searchParams.append('telephone', address);
  callUrl.searchParams.append('x-source', 'MS Teams Integration');
  callUrl.searchParams.append('autoJoin', 'true');
  callUrl.searchParams.append('videoCall', `${video ? 'true' : 'false'}`);
  callUrl.searchParams.append('mutedCall', 'false');
  // Keep the native call controls available for audio launches; `videoCall`
  // is the flag that selects the requested media mode.
  callUrl.searchParams.append('audioOnlyCall', 'false');
  return callUrl.href;
};
